import { type TableColumn, Typography } from "@kyan/ui";

import { tooltips } from "#/config/tooltips";
import { type RFQResponseState } from "#/services/kyan/kyan.types";
import { formatInstrumentName } from "#/utils/instrument.utils";
import { formatCompact, formatCurrency } from "#/utils/valueFormatters";

import { RfqDirection } from "../RfqDirection/RfqDirection";
import { RfqResponseAction } from "../RfqResponseAction/RfqResponseAction";
import { RfqRiskChange } from "../RfqRiskChange/RfqRiskChange";

export const singleLegColumns: TableColumn<RFQResponseState>[] = [
  {
    id: "instrument",
    minWidth: "220px",
    cellClassName: "pl-10",
    cell: (row) => formatInstrumentName(row.legs[0].instrumentName),
  },
  {
    id: "side",
    maxWidth: "70px",
    cell: (row) => <RfqDirection response={row} />,
    tooltip: tooltips.side,
  },
  {
    id: "price",
    maxWidth: "80px",
    cell: (row) => (
      <Typography>
        {formatCurrency(row.legs[0].price ?? 0, { template: "0.00" })}
      </Typography>
    ),
    tooltip: tooltips.price,
  },
  {
    id: "size",
    maxWidth: "50px",
    cell: (row) => (
      <Typography>{formatCompact(row.legs[0].size ?? 0)}</Typography>
    ),
  },
  {
    id: "imr",
    cell: (response) => (
      <RfqRiskChange isPercent riskMetric="imr" response={response} />
    ),
    minWidth: "130px",
    tooltip: tooltips.imr,
  },
  {
    id: "mmr",
    cell: (response) => (
      <RfqRiskChange isPercent riskMetric="mmr" response={response} />
    ),
    minWidth: "130px",
    tooltip: tooltips.mmr,
  },
  {
    id: "delta",
    cell: (response) => (
      <RfqRiskChange riskMetric="delta" response={response} />
    ),
    minWidth: "110px",
    tooltip: tooltips.delta,
  },
  {
    id: "gamma",
    cell: (response) => (
      <RfqRiskChange
        riskMetric="gamma"
        response={response}
        template="0.000000"
      />
    ),
    minWidth: "140px",
    tooltip: tooltips.gamma,
  },
  {
    id: "vega",
    cell: (response) => <RfqRiskChange riskMetric="vega" response={response} />,
    minWidth: "110px",
    tooltip: tooltips.vega,
  },
  {
    id: "theta",
    cell: (response) => (
      <RfqRiskChange riskMetric="theta" response={response} />
    ),
    minWidth: "130px",
    tooltip: tooltips.theta,
  },
  {
    id: "netPrice",
    cell: (response) => (
      <Typography>
        {formatCurrency(response.legs[0].netPrice, {
          precision: 0,
        })}
      </Typography>
    ),
    tooltip: tooltips.netPrice,
    minWidth: "130px",
  },
  {
    id: "action",
    cell: (response) => <RfqResponseAction response={response} />,
  },
];
